module.exports = __webpack_public_path__ + "img/square-download.3a83d348.svg";